// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/contractintel/v1/contractintel.proto (package mono.contractintel.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { AnalyzeContractRequest, AnalyzeContractResponse, AnalyzeSOWRequest, AnalyzeSOWResponse, ApplyModificationRequest, ApplyModificationResponse, DeleteContractRequest, DeleteContractResponse, DownloadSubmissionRequest, DownloadSubmissionResponse, ExportCLINsCSVRequest, ExportCLINsCSVResponse, ExtractInvoiceMetadataRequest, ExtractInvoiceMetadataResponse, GenerateBillingScheduleRequest, GenerateBillingScheduleResponse, GeneratePMPRequest, GeneratePMPResponse, GetCLINRequest, GetCLINResponse, GetContractRequest, GetContractResponse, GetContractStatusRequest, GetContractStatusResponse, GetModificationDiffRequest, GetModificationDiffResponse, GetModificationRequest, GetModificationResponse, ListContractsRequest, ListContractsResponse, ListDeliverableSubmissionsRequest, ListDeliverableSubmissionsResponse, ListModificationsRequest, ListModificationsResponse, ParseModificationRequest, ParseModificationResponse, PingRequest, PingResponse, QueryCLINsRequest, QueryCLINsResponse, QueryDeliverablesRequest, QueryDeliverablesResponse, SubmitDeliverableRequest, SubmitDeliverableResponse, UpdateCLINFundingRequest, UpdateCLINFundingResponse, UpdateDeliverableStatusRequest, UpdateDeliverableStatusResponse } from "./contractintel_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * ContractIntelService provides contract intelligence, analysis, amendments,
 * and derived artifact generation for GovCon contracts.
 * Hosted by iceburg, consumed by shanks (agent tools) and thousand-sunny (frontend).
 *
 * ======================== Analysis RPCs ========================
 *
 * @generated from service mono.contractintel.v1.ContractIntelService
 */ export const ContractIntelService = {
    typeName: "mono.contractintel.v1.ContractIntelService",
    methods: {
        /**
     * Orchestrate full contract analysis: document → baltigo extraction → LLM enrichment → persist.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.AnalyzeContract
     */ analyzeContract: {
            name: "AnalyzeContract",
            I: AnalyzeContractRequest,
            O: AnalyzeContractResponse,
            kind: MethodKind.Unary
        },
        /**
     * Analyze a Statement of Work: extract scope, timeline, stakeholders, kickoff requirements.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.AnalyzeSOW
     */ analyzeSOW: {
            name: "AnalyzeSOW",
            I: AnalyzeSOWRequest,
            O: AnalyzeSOWResponse,
            kind: MethodKind.Unary
        },
        /**
     * Check whether a contract has been analyzed and its current status.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.GetContractStatus
     */ getContractStatus: {
            name: "GetContractStatus",
            I: GetContractStatusRequest,
            O: GetContractStatusResponse,
            kind: MethodKind.Unary
        },
        /**
     * Extract the issue/submission date from an uploaded invoice so a form can
     * pre-fill it. Best-effort: an unreadable invoice returns an empty date.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.ExtractInvoiceMetadata
     */ extractInvoiceMetadata: {
            name: "ExtractInvoiceMetadata",
            I: ExtractInvoiceMetadataRequest,
            O: ExtractInvoiceMetadataResponse,
            kind: MethodKind.Unary
        },
        /**
     * Retrieve a contract analysis by ID or contract number.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.GetContract
     */ getContract: {
            name: "GetContract",
            I: GetContractRequest,
            O: GetContractResponse,
            kind: MethodKind.Unary
        },
        /**
     * List contracts for a project or organization.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.ListContracts
     */ listContracts: {
            name: "ListContracts",
            I: ListContractsRequest,
            O: ListContractsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Soft-delete a contract analysis and its related entities.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.DeleteContract
     */ deleteContract: {
            name: "DeleteContract",
            I: DeleteContractRequest,
            O: DeleteContractResponse,
            kind: MethodKind.Unary
        },
        /**
     * Query CLINs with filtering, sorting, and pagination.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.QueryCLINs
     */ queryCLINs: {
            name: "QueryCLINs",
            I: QueryCLINsRequest,
            O: QueryCLINsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Get a single CLIN by ID.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.GetCLIN
     */ getCLIN: {
            name: "GetCLIN",
            I: GetCLINRequest,
            O: GetCLINResponse,
            kind: MethodKind.Unary
        },
        /**
     * Update a CLIN's funding status or tracked amounts.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.UpdateCLINFunding
     */ updateCLINFunding: {
            name: "UpdateCLINFunding",
            I: UpdateCLINFundingRequest,
            O: UpdateCLINFundingResponse,
            kind: MethodKind.Unary
        },
        /**
     * Export CLINs for a contract as CSV bytes.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.ExportCLINsCSV
     */ exportCLINsCSV: {
            name: "ExportCLINsCSV",
            I: ExportCLINsCSVRequest,
            O: ExportCLINsCSVResponse,
            kind: MethodKind.Unary
        },
        /**
     * Query deliverables with filtering and pagination.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.QueryDeliverables
     */ queryDeliverables: {
            name: "QueryDeliverables",
            I: QueryDeliverablesRequest,
            O: QueryDeliverablesResponse,
            kind: MethodKind.Unary
        },
        /**
     * Update a deliverable's status.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.UpdateDeliverableStatus
     */ updateDeliverableStatus: {
            name: "UpdateDeliverableStatus",
            I: UpdateDeliverableStatusRequest,
            O: UpdateDeliverableStatusResponse,
            kind: MethodKind.Unary
        },
        /**
     * Submit a file for a deliverable (upload to storage + create submission record).
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.SubmitDeliverable
     */ submitDeliverable: {
            name: "SubmitDeliverable",
            I: SubmitDeliverableRequest,
            O: SubmitDeliverableResponse,
            kind: MethodKind.Unary
        },
        /**
     * List submission history for a deliverable.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.ListDeliverableSubmissions
     */ listDeliverableSubmissions: {
            name: "ListDeliverableSubmissions",
            I: ListDeliverableSubmissionsRequest,
            O: ListDeliverableSubmissionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Download a submitted file.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.DownloadSubmission
     */ downloadSubmission: {
            name: "DownloadSubmission",
            I: DownloadSubmissionRequest,
            O: DownloadSubmissionResponse,
            kind: MethodKind.Unary
        },
        /**
     * Parse an SF30 modification document and persist the extracted changes.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.ParseModification
     */ parseModification: {
            name: "ParseModification",
            I: ParseModificationRequest,
            O: ParseModificationResponse,
            kind: MethodKind.Unary
        },
        /**
     * List modifications for a contract.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.ListModifications
     */ listModifications: {
            name: "ListModifications",
            I: ListModificationsRequest,
            O: ListModificationsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Get a single modification by ID.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.GetModification
     */ getModification: {
            name: "GetModification",
            I: GetModificationRequest,
            O: GetModificationResponse,
            kind: MethodKind.Unary
        },
        /**
     * Apply a parsed modification: update CLINs, funding, periods, etc.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.ApplyModification
     */ applyModification: {
            name: "ApplyModification",
            I: ApplyModificationRequest,
            O: ApplyModificationResponse,
            kind: MethodKind.Unary
        },
        /**
     * Compare two modification states to produce a diff summary.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.GetModificationDiff
     */ getModificationDiff: {
            name: "GetModificationDiff",
            I: GetModificationDiffRequest,
            O: GetModificationDiffResponse,
            kind: MethodKind.Unary
        },
        /**
     * Generate a Project Management Plan from contract data.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.GeneratePMP
     */ generatePMP: {
            name: "GeneratePMP",
            I: GeneratePMPRequest,
            O: GeneratePMPResponse,
            kind: MethodKind.Unary
        },
        /**
     * Generate a billing/invoicing schedule from CLINs and contract type.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.GenerateBillingSchedule
     */ generateBillingSchedule: {
            name: "GenerateBillingSchedule",
            I: GenerateBillingScheduleRequest,
            O: GenerateBillingScheduleResponse,
            kind: MethodKind.Unary
        },
        /**
     * Health check RPC.
     *
     * @generated from rpc mono.contractintel.v1.ContractIntelService.Ping
     */ ping: {
            name: "Ping",
            I: PingRequest,
            O: PingResponse,
            kind: MethodKind.Unary
        }
    }
};
